<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col md="6" >
        <b-form-group :label="`${$t('FIRST_NAME_LAST_NAME')} *`">
          <b-form-input v-model="userData.name" type="text"></b-form-input>
          <validation-description :show="$v.userData.name.$dirty && $v.userData.name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Email *">
          <b-form-input v-model="userData.email"  type="text"></b-form-input>
          <validation-description :show="$v.userData.email.$dirty && $v.userData.email.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="`${$t('ROLE')} *`">
          <b-form-select v-model="userData.role">
            <option :value="null">-</option>
            <option :key="index" v-for="(role, index) in roles" :value="role.id">
              {{ role.name }}
            </option>
          </b-form-select>
          <validation-description :show="$v.userData.role.$dirty && $v.userData.role.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" >
      <b-form-group :label="`${$t('PASSWORD')} *`">
        <b-form-input v-model="userData.password"  type="text"></b-form-input>
        <validation-description :show="$v.userData.password.$dirty && $v.userData.password.$invalid">
          {{$t('FIELD_MANDATORY')}}
        </validation-description>
      </b-form-group>
    </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col sm="6" md="6" lg="6">
        <app-button-submit :loading="loading" ></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {getRoleList} from "@/services/role"
  import {required, minLength} from 'vuelidate/lib/validators'
  import i18n from '@/locale/index'
  import {createUser} from "@/services/user"
  import {toast} from "@/shared/plugins/toastr"
  import {getErrorMessage} from "@/mixins/error/getErrorMessage"
  export default {
      name: "UserNewForm",
      mixins:[getErrorMessage],
      data() {
        return {
          options_status:[
            {value:1, text: i18n.t('ACTIVE')},
            {value:0, text: i18n.t('NOTACTIVE')}
          ],
          roles:[],
          userData: {
            name: null,
            email: null,
            role:null,
            password: null,
            active:1,
          },
          loading:false,
          disableClient: true,
          clientValidationError: false,
        }
      },
      components:{
        ValidationDescription,
        AppButtonSubmit,
      },
      validations:{
        userData: {
          name:{required},
          email:{required},
          role:{required},
          password:{required,
            minLength:  minLength(6)
          },
        }
      },
      methods: {
        getData() {
          getRoleList()
             .then(response => {
               this.roles = response.data
            })
        },
        save() {
          this.$v.userData.$touch()
          if(this.$v.userData.$invalid){
            toast({
              'title': this.$t('VALIDATION_FAILED'),
              'message': null,
              'type': 'error',
              'timeout': 4000
            })
            return
          }
          this.loading = true
          const request = {
            name: this.userData.name,
            email: this.userData.email,
            role: this.userData.role,
            password: this.userData.password,
            active: this.userData.active,
          }
          createUser(request).then(() => {
            toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })
              this.$store.dispatch('user/actionSearch')
              this.$emit('closePanel', this.editAsidePanel)
          }, error => {
            toast({
              title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
          }).finally(()=>{
            this.loading = false
          })
        },
      },
      async mounted () {
        await this.getData();
      }
    }
</script>

<style scoped>
.table.-no-padding td{
  padding-left: 0;
  padding-right: 0;
}
.btn-del{
  background: none;
  font-size: 18px;
  border: unset;
}
</style>
